import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.Wallets.AddCurrenciesPopupContent', {
    title: 'Add new currency',
    description: 'Select which currencies you would like to add to your wallets',
    currency: 'Currency',
    currencyPlaceholder: 'Select currency...',
    add: 'Add',
});
